export class UnknownRecipeIdentifier extends Error {
  constructor(identifier, recipe, ...params) {
    super(...params)

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, UnknownRecipeIdentifier)
    }

    this.identifier = identifier
    this.recipe = recipe
    this.message = `Unknown identifier "${identifier}" in recipe "${recipe}"`
  }
}

export class ParsingUnsuccessful extends Error {
  constructor(recipe, ...params) {
    super(...params)

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ParsingUnsuccessful)
    }

    this.recipe = recipe
    this.message = `Recipe "${recipe}" could not be parsed.`
  }
}
